import { inject, Injectable } from '@angular/core';
import { map, Observable, startWith } from 'rxjs';
import { MenuParams } from '../../../shared/page/menu.config';
import { Store } from '@ngrx/store';
import { UserSelector } from 'src/app/shared/store/user/user.feature';

@Injectable({
  providedIn: 'root',
})
export class MenuParamsService {
  private store = inject(Store);

  // Configure this
  menuParams$: Observable<MenuParams> = this.store
    .select(UserSelector.selectIsEditor)
    .pipe(
      startWith(false),
      map(isEditor => ({ isEditor, isDebug: false })),
    );
}
